import { LanguageOutlined, Menu, MenuOpenOutlined } from "@mui/icons-material";
import { Box, Grid, InputBase } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import React from "react";
import { Link } from "react-router-dom";
import { theme } from "../../../theme";
import AvatarMenu from "./Avater";


const TopBar = ({ setOpen, open, isCollapse, setIsCollapse }) => {
  const toggleDrawer = () => {
    setOpen(!open);
  };
  
  const origin = window.location.origin;
  return (
    <>
      <Box
        mb={2}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        position={"sticky"}
        top={0}
        left={0}
        right={0}
        zIndex={99}
        boxShadow={theme.palette.boxShadow}
        sx={{
          background: "#fff",
          backdropFilter: "blur(1px)",
        }}
      >
        <div className="d-flex gap-3 align-items-center mx-2">
          <div
            className="d-none d-md-block"
            onClick={() => {
              setIsCollapse(!isCollapse);
            }}
          >
            <MenuOpenOutlined
              sx={{ transition: "transform 0.6s ease-in-out" }}
              className="cursor-pointer"
              style={{
                transform: isCollapse ? "rotate(-180deg)" : "",
              }}
            />
          </div>
          <Link to={origin} target="_blank">
            <LanguageOutlined />
          </Link>
        </div>

        <Grid container spacing={2} alignItems="end">
          <Grid item xs={12} position={"sticky"} top={0} left={0} right={0}>
            <Box
              display={"flex"}
              alignItems={"end"}
              justifyContent={"flex-end"}
              borderRadius={"30px"}
              p={1}
              pl={{ md: 2 }}
              sx={{
                float: "right",
                width: { xs: "-webkit-fill-available", md: "fit-content" },
              }}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{ width: { xs: "100%", md: "auto" } }}
              >
                <Box
                  color="inherit"
                  aria-label="Open sidebar"
                  edge="start"
                  onClick={toggleDrawer}
                  sx={{
                    cursor: "pointer",
                    display: { xs: "block", md: "none" },
                    // ml: 2,
                  }}
                >
                  <Menu />
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  {/* <Link to={"/admin/profile"}>
                    <Badge
                      max={9}
                      badgeContent={10}
                      color="secondary"
                      sx={{
                        marginRight: "30px",
                      }}
                    >
                      <NotificationsActiveOutlined
                        sx={{ fontSize: "21px" }}
                        color="action"
                      />
                    </Badge>
                  </Link>
                  <Link to={"/admin/profile"}>
                    <Badge
                      max={9}
                      badgeContent={10}
                      color="secondary"
                      sx={{
                        marginRight: "30px",
                      }}
                    >
                      <EmailOutlined sx={{ fontSize: "21px" }} color="action" />
                    </Badge>
                  </Link> */}
                  <AvatarMenu />
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default TopBar;
